<template>
  <div>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin: 20px 0 20px 20px"
      >
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>专业列表</el-breadcrumb-item>
      </el-breadcrumb>
    
    <!-- 卡片视图 -->
    <el-card>
      
      <el-row :gutter="40">
        <el-col :span="20">
          <el-col :span="8">
            <!-- clearable: 输入框可清空 -->
            <!-- @clear: 输入框清空之后执行 -->
            <el-input placeholder="请输入专业名称" v-model="name" clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-search" @click="searchFn"
              >查询</el-button
            >
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addOrUpdateMajor"
            >添加专业</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!-- 用户列表展示 -->
    <div class="table">
      <el-table
        :data="majorList"
        border
        stripe
        style="width: 95%; margin: 10px auto"
      >
        <!-- 索引列 -->
        <el-table-column
          type="index"
          label="索引"
          width="50px"
        ></el-table-column>
        <el-table-column prop="zydm" label="专业代码"></el-table-column>
        <el-table-column prop="zymc" label="专业名称"></el-table-column>
        <el-table-column prop="xlcc" label="学历层次"></el-table-column>
        <el-table-column prop="ml" label="门类"></el-table-column>
        <el-table-column prop="zyl" label="专业类"></el-table-column>
        <!-- <el-table-column prop="zyjs" label="专业介绍"></el-table-column> -->
        <el-table-column prop="xjzy" label="相近专业"></el-table-column>
        <el-table-column prop="zyxskyfx" label="考研方向"></el-table-column>
        <el-table-column prop="byrycyfx" label="毕业从业方向"></el-table-column>
        <el-table-column label="操作" width="150">
          <!-- 利用自定义作用域插槽来解决在一个table-column里同时展示多个图标的问题 -->
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-button
              type="primary"
              @click="addOrUpdateMajor(scope.row)"
              icon="el-icon-edit"
              size="mini"
            ></el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delFn(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <!-- size-change: 改变底部栏中m条/页的数据会触发 -->
    <!-- current-change: 当前页码值发生改变时会触发 -->
    <!-- page-sizes="[1, 2, 5, 10]: 1条/页 2条/页 5条/页 10条/页-->
    <el-pagination
      style="margin-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <el-dialog
      :title="isUpdate ? '修改专业' : '添加专业'"
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="100px"
      >
        <el-form-item label="专业代码" prop="zydm">
          <el-input v-model="addForm.zydm" v-if="isUpdate" disabled></el-input>
          <el-input v-model="addForm.zydm" v-else></el-input>
        </el-form-item>
        <el-form-item label="专业名称" prop="zymc">
          <el-input v-model="addForm.zymc"></el-input>
        </el-form-item>
        <el-form-item label="学历层次" prop="xlcc">
          <el-input v-model="addForm.xlcc"></el-input>
        </el-form-item>
        <el-form-item label="门类" prop="mldm">
          <!-- <el-input v-model="addForm.ml"></el-input> -->
          <el-select v-model="addForm.mldm" placeholder="请选择门类" >
            <el-option
              v-for="item in majorListML"
              :key="item.categoryCode"
              :label="item.categoryName"
              :value="item.categoryCode"
              @click.native="selectMLByGroupId(item)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业类" prop="zyldm">
          <!-- <el-input v-model="addForm.zyl"></el-input> -->
          <el-select v-model="addForm.zyldm" placeholder="请选择专业类">
            <el-option
              v-for="item in majorListZYL"
              :key="item.professionCode"
              :label="item.categoryName"
              :value="item.professionCode"
              @click.native="selectZYLByGroupId(item)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业介绍" prop="zyjs">
          <el-input v-model="addForm.zyjs"></el-input>
        </el-form-item>
        <el-form-item label="相近专业" prop="xjzy">
          <el-input v-model="addForm.xjzy"></el-input>
        </el-form-item>
        <el-form-item label="考研方向" prop="xjzy">
          <el-input v-model="addForm.zyxskyfx"></el-input>
        </el-form-item>
        <el-form-item label="从业方向" prop="byrycyfx">
          <el-input v-model="addForm.byrycyfx"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser('addFormRef')"
          >确 定</el-button
        >
        <el-button @click="addDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import subsystyem from '../../api/adaptation'
export default {
  created() {
    this.getMajorList()
    this.getMajorML()
  },
  data() {
    return {
      // 获取用户列表参数(有模糊查询)
      queryInfo: {
        // 当query为null时默认查询所有人的数据
        //当前页数
        pagenum: 1,
        //每一页展示的数据量
        pagesize: 10
      },
      // 查询的专业名
      name: '',
      majorList: [],
      majorListML: [],
      majorListZYL: [],
      total: 0,
      // 是否展示提示框   
      addDialogVisible: false,
      // 添加用户的数据对象
      addForm: {
        zydm: '',
        zymc: '',
        xlcc: '',
        mldm: '',
        ml: '',
        zyldm: '',
        zyl: '',
        zyjs: '',
        xjzy: '',
        zyxskyfx: '',
        byrycyfx: ''
      },
      isUpdate: false,
      addFormRules: {
        zydm: [{ required: true, message: '请输入专业代码', trigger: 'blur' }],
        zymc: [{ required: true, message: '请输入专业名称', trigger: 'blur' }],
        xlcc: [{ required: true, message: '请输入学历层次', trigger: 'blur' }],
        ml: [{ required: true, message: '请输入门类', trigger: 'blur' }]
      }
    };
  },
  methods: {
    selectMLByGroupId(e) {
      this.addForm.ml = e.categoryName
      this.getMajorProfessional(e.categoryCode)
    },
    selectZYLByGroupId(e) {
      this.addForm.zyl = e.categoryName
    },
    getMajorML() {
      subsystyem.getMajorML().then(res => {
        this.majorListML = res.list
      })
    },
    getMajorProfessional(code) {
      subsystyem.getMajorProfessional({
        'mldm': code
      }).then(res => {
        this.majorListZYL = res.list
      })
    },
    // 得到所有专业 or 模糊查询
    getMajorList() {
      let data = {
        current: this.queryInfo.pagenum,
        size: this.queryInfo.pagesize,
        name: this.name
      }
      subsystyem.getMajor(data).then(res => {
        this.majorList = res.list
        this.total = res.total
      })
    },
    // 查询
    searchFn() {
      let data = {
        current: 1,
        size: this.queryInfo.pagesize,
        name: this.name
      }
      subsystyem.getMajor(data).then(res => {
        this.majorList = res.list
        this.total = res.total
      })
    },

    // 添加或者更新专业
    addOrUpdateMajor(zy) {
      let self = this
      self.addForm = {}
      if (zy.zydm != undefined && zy.zydm != null && zy.zydm != '' && zy.zydm.length > 0) {
        self.addForm = JSON.parse(JSON.stringify(zy))
        self.isUpdate = true
      }
      else
        self.isUpdate = false
      self.addDialogVisible = true
    },


    //监听底部分页栏 pagesize 改变的事件
    handleSizeChange(newSize) {
      //console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getMajorList();
    },
    //监听底部分页面页码值发生改变的时间
    handleCurrentChange(newPage) {
      //console.log(newPage)
      this.queryInfo.pagenum = newPage;
      this.getMajorList();
    },
    // 当把添加用户框关闭的时候把数据清空
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 点击添加用户按钮时，给数据进行校验
    addUser(from) {
      console.log("this.addForm", this.addForm);
      this.$refs[from].validate(valid => {
        if (!valid) return
        if (this.isUpdate) {
          subsystyem.updateMajor(this.addForm).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.name = ''
            this.getMajorList();
            this.addDialogVisible = false
          })
        } else {
          subsystyem.addMajor(this.addForm).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            });
            this.name = ''
            this.getMajorList();
            this.addDialogVisible = false
          })
        }

      })
    },
    delFn(row) {
      this.$confirm('此操作将永久删除该专业, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        subsystyem.deleteMajorByzydm(row.zydm).then(res => {
          this.getMajorList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.table {
  width: 100%;
  margin-top: -10px;
  background: #fff;
  padding: 20px 0;
}
</style>